/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';

import { Events, handleAnalytics } from '@foxcorp/delta-web-analytics';
import { isInternalLink, LINK_REL } from 'helpers/ContentHelper';
import SocialIcon from 'components/Social';

const LinkItem = props => {
  const { theme, item, isSocial } = props;
  const { brand, text, link } = item;
  const hasSlash = text.includes('/');

  const isNullTarget = isInternalLink(link) || !link;

  const socialIcon = brand ? (
    <div className={theme.brandLogo}>
      <SocialIcon brand={brand} color="white" />
    </div>
  ) : null;
  const anchorClasses = classNames([theme.link, isSocial && theme.socialLink]);

  const target = isNullTarget ? null : '_blank';
  const rel = isNullTarget ? null : LINK_REL;
  const onClick = () => {
    handleAnalytics({
      event: Events.FOOTER_LINK_CLICKED,
      payload: { page_item_title: text },
    });

    return this.onNavClick && this.onNavClick();
  };

  const anchorProps = {
    key: _.uniqueId(),
    href: link,
    className: anchorClasses,
    onClick,
    target,
    rel,
  };

  return (
    <a {...anchorProps}>
      {socialIcon}
      {hasSlash ? (
        <div className={theme.linkTextContainer}>
          {text.split('/').map((line, index) => (
            <div key={`link-${index}`} className={theme.linkText}>{`${line}${
              index === 0 ? `/` : ''
            }`}</div>
          ))}
        </div>
      ) : (
        <span className={theme.linkText}>{text}</span>
      )}
    </a>
  );
};

export default LinkItem;

LinkItem.defaultProps = {
  isSocial: false,
  item: {},
  theme: {},
};

LinkItem.propTypes = {
  isSocial: PropTypes.bool,
  item: PropTypes.shape({}),
  theme: PropTypes.shape({}),
};
